import { render, staticRenderFns } from "./ModifyOrder.vue?vue&type=template&id=83b022d6&scoped=true"
import script from "./ModifyOrder.vue?vue&type=script&lang=js"
export * from "./ModifyOrder.vue?vue&type=script&lang=js"
import style0 from "./ModifyOrder.vue?vue&type=style&index=0&id=83b022d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b022d6",
  null
  
)

export default component.exports